import React from 'react';
import LegalDocumentPage from './LegalDocumentPage.jsx';

export default function PrivacyPolicy() {
  return <LegalDocumentPage docType="privacy" pageTitle="Privacy Policy" />;
}
